import Delegate from "//www.ohmycream.com/cdn/shop/t/168/assets/ftdomdelegate.min.js?v=167457923630348017651677856387";

export class SliderQuizz extends HTMLElement {
  connectedCallback() {
    this._sliderManager();
  }

  _sliderManager() {
    // init slider
    let $slider = $(this).find('.skin-type-result-slideshow');
    //window.onload = function() {
    window.addEventListener('DOMContentLoaded', function() {
      $slider.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 15 30"><path d="M1 1L14 15L1 29"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 15 30"><path d="M1 1L14 15L1 29"/></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              arrows: false
            }
          }
        ]
      });
    });
  }
}

try {
  window.customElements.define('slider-quizz', SliderQuizz);
} catch(e) {}